// extracted by mini-css-extract-plugin
module.exports = {"creditBureauHeading":"CreditBureau_creditBureauHeading__3PxJt"};